// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
export * from './RouterCustomerManagement'
import * as sosCustomerManagement from './sosCustomerManagement'
export { sosCustomerManagement }